import { delay, put, select } from 'redux-saga/effects';
import axios from '../../axios-local-api';
import * as actions from '../actions';

export function* updateWifiSecurityChangeAllSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      yield put(actions.setWifiSecurityLoading())
     const response = yield axios.post(
        '/updateWifiSecurityBands',
       {
        MAC: rMac,
        bToken: token,
        securityBands: action.securityBands,
        sessionToken: sessionToken
       }
      )
      if (response?.status === 200) {
        yield put(actions.setWifiSecuritySuccess(response?.data));
        yield put(actions.getAllWifiSecuritySummary());
      } else {
        yield put(actions.setWifiSecurityFail());
      }
    } catch (error) {
      yield put(actions.setWifiSecurityFail());
    }
  }
}

export function* setWifiSecurityBandSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
     let response = {};
         response = yield axios.post(
          '/addWifiServiceBands',
          {
            rMac: rMac,
            bToken: token,
            settingId: action.payload.settingId,
            sessionToken: sessionToken,
            optionValue: action.payload.security
          }
        )
        if (response?.status === 200) {
          yield put(actions.setWifiSecuritySuccess());
          if (action.payload.setShowSuccessModal) {
            action.payload.setShowSuccessModal(true);
          }
          yield put(actions.getAllWifiSecuritySummary());
        } else {
          yield put(actions.setWifiSecurityFail());
          if (action.payload.setShowErrorModal) {
            action.payload.setShowErrorModal(true);
          }
        }
    } catch (error) {
      yield put(actions.setWifiSecurityFail());
      if (action.payload.setShowErrorModal) {
        action.payload.setShowErrorModal(true);
      }
    }
  } else {
    yield put(actions.setWifiSecurityFail());
    if (action.payload.setShowErrorModal) {
      action.payload.setShowErrorModal(true);
    }
  }
}

// export function* getAllWifiSecuritySummarySaga() {
//   const rMac = yield sessionStorage.getItem('mac');
//   const token = yield sessionStorage.getItem('token');
//   const sessionToken = yield sessionStorage.getItem('sessionToken');
//   if (sessionToken) {
//     try {
//      let response = {};

//      response = yield axios.post(
//         '/getAllWifiSecuritySummary',
//         {
//           rMac: rMac || '',
//           bToken: token,
//           sessionToken:sessionToken
//         }
//       ).then(res=>{
//         return res;
//       })

//       if (response?.status === 200) {
//         yield put(actions.setWifiSecuritySuccess(response?.data));
//       } else {
//         yield put(actions.setWifiSecurityFail());
//       }
//     } catch (error) {
//       yield put(actions.setWifiSecurityFail());
//     }
//   }
// }



